import { matchPath, useLocation } from "react-router-dom";
import PageMetadata from "./PageMetadata";

const pageTitles: Record<string, string> = {
  "/": "Discover events",
  "/terms-of-service": "Terms of Service",
  "/privacy-policy": "Privacy Policy",
  "/data-deletion": "Data Deletion",
  "/download-app": "Download the app",
};

export default function RouteMetadata() {
  const { pathname } = useLocation();
  const pagePath = pathname.replace(/\/+$/, "") || "/";
  let title = pageTitles[pagePath];
  if (!title) {
    if (matchPath("/e/:slug", pathname) || matchPath("/events/:id", pathname)) title = "Event details";
    else if (matchPath("/p/:publicId", pathname) || matchPath("/posts/:id", pathname)) title = "Community post";
    else if (pathname.startsWith("/link/")) title = "Open in the app";
    else title = "Member profile";
  }
  // Every route owns a baseline. Loaded detail pages supply their specific metadata.
  return <PageMetadata title={title} url={pathname} />;
}
